module.exports = __webpack_public_path__ + "static/media/dark-modulo-comercial.870dea08.svg";